import React from 'react';
import { DatePicker as MDatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';

export const DatePicker = props => {
  const val = props.value;
  const mValue = val == null ? val : moment.isMoment(val) ? val : moment(val);
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MDatePicker format="MM/DD/YYYY" {...props} value={mValue} />
    </LocalizationProvider>
  )
}